import { ENV, KULEWEBVIEW_ANDROID, KULEWEBVIEW_IOS } from '@/config/constant'
import TGASDK, { TGASDKInit } from '@/config/TGASDK'
import i18n, { i18nInit } from '@/i18n'
import ReactDOM from 'react-dom/client'
import App from './App'
import InjectGoogleGPTScript from './component/InjectScript/GoogleGPTScript'
import adxInit from './config/adx'
import { getBaseAppParams } from './helper'
import logger from './helper/logger'
import './index.css'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

window.Bridge.onReady = async () => {
  const { appCode } = await getBaseAppParams()
  const resourceReady = TGASDK.resourceReady({
    env: ENV,
    appCode
  })
  if (!resourceReady) {
    document.getElementById('root-loader')!.style.display = 'flex'
  }

  // SDK初始化
  await TGASDKInit()

  // 皮肤处理
  document.documentElement.setAttribute('data-theme', TGASDK.context.appConfig.defaultTheme)
  // 平台处理
  document.documentElement.setAttribute(
    'data-client',
    KULEWEBVIEW_IOS ? 'iOS' : KULEWEBVIEW_ANDROID ? 'android' : 'web'
  )

  // 统计配置
  window.dataKule.push('config', {
    env: TGASDK.context.env,
    appId: TGASDK.context.appConfig.appId
  })

  // Google ADX广告
  adxInit()

  // i18n初始化
  i18nInit()
    .then(() => {
      document.documentElement.lang = i18n.language
      document.documentElement.dir = i18n.dir(i18n.language)

      logger.info('i18n init success')
    })
    .catch(error => {
      logger.error('i18n init error', error)
    })

  root.render(
    <>
      <App />
      <InjectGoogleGPTScript />
    </>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
